import { render, staticRenderFns } from "./AdminContactsListView.vue?vue&type=template&id=dcc8ddec&scoped=true"
import script from "./AdminContactsListView.vue?vue&type=script&lang=js"
export * from "./AdminContactsListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc8ddec",
  null
  
)

export default component.exports